import { render } from "./FooterSmall.vue?vue&type=template&id=832c2584"
import script from "./FooterSmall.vue?vue&type=script&lang=js"
export * from "./FooterSmall.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Master\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__